import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=36ae735e&"
import script from "./FormModal.vue?vue&type=script&lang=js&"
export * from "./FormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ae735e')) {
      api.createRecord('36ae735e', component.options)
    } else {
      api.reload('36ae735e', component.options)
    }
    module.hot.accept("./FormModal.vue?vue&type=template&id=36ae735e&", function () {
      api.rerender('36ae735e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomField/Choice/FormModal.vue"
export default component.exports